import z from "zod";
import { GrantsSchema, ProjectIdSchema, RoleNameSchema } from "@storytell/types";
// {
//  "projectId": "project_d3n00hk9e1j3pa9sbcv0",
//  "grants": {
//    "cp.assets": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.chats": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.concepts": {
//      "op.create": false,
//      "op.delete": false,
//      "op.read": true,
//      "op.update": false
//    },
//    "cp.grants": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.label_associations": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.labels": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.messages": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.plans": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.projects": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.public_assets": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.user_context": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    },
//    "cp.views": {
//      "op.create": true,
//      "op.delete": true,
//      "op.read": true,
//      "op.update": true
//    }
//  },
//  "roleName": "role.owner"
//}
// Grant ID type - represents a resource identifier like "cp.assets", "cp.chats", etc.
export const GrantsIds = [
  "cp.assets",
  "cp.chats",
  "cp.concepts",
  "cp.grants",
  "cp.invitations",
  "cp.invitations_domains",
  "cp.invitations_users",
  "cp.label_associations",
  "cp.labels",
  "cp.messages",
  "cp.plans",
  "cp.projects",
  "cp.public_assets",
  "cp.user_context",
  "cp.views",
  "_x.project_participants",
] as const;

export const GrantIdSchema = z.enum(GrantsIds);
export type GrantId = z.infer<typeof GrantIdSchema>;

// Individual grant object with permissions for a specific resource
export const GrantSchema = z.object({
  grants: GrantsSchema,
});
export type Grant = z.infer<typeof GrantSchema>;

// User focused grants response schema based on the example response
export const UserFocusedGrantsResponseSchema = z.object({
  projectId: ProjectIdSchema,
  grants: z.record(GrantIdSchema.or(z.string()), GrantsSchema),
  roleName: RoleNameSchema,
});
export type UserFocusedGrantsResponse = z.infer<typeof UserFocusedGrantsResponseSchema>;
